export enum AsyncComponentPantoneEnum {
    PantoneMutate = 'PantoneMutate',
    PantoneTabs = 'PantoneTabs',
    PantoneList = 'PantoneList',
    PantoneListForm = 'PantoneListForm',
    PantoneMutateForm = 'PantoneMutateForm',

    ColorList = 'ColorList',
    ColorListForm = 'ColorListForm',
    ColorMutateForm = 'ColorMutateForm',
    ColorMutate = 'ColorMutate',

    PantoneColor = 'PantoneColor',
    PantoneSelector = 'PantoneSelector',
    ColorSelector = 'ColorSelector',
    PantoneProductModel = 'PantoneProductModel',
    MaterialTypeColorSelector = 'MaterialTypeColorSelector',

}

export const pantoneComponents = {
    [ AsyncComponentPantoneEnum.PantoneListForm ]: () => import( '@/components/pantone/PantoneListForm.vue' ),
    [ AsyncComponentPantoneEnum.PantoneMutateForm ]: () => import( '@/components/pantone/PantoneMutateForm.vue' ),
    [ AsyncComponentPantoneEnum.PantoneMutate ]: () => import( '@/views/pantone/pantoneMutate/PantoneMutate.vue' ),

    [ AsyncComponentPantoneEnum.PantoneTabs ]: () => import( '@/components/pantone/PantoneTabs.vue' ),
    [ AsyncComponentPantoneEnum.PantoneList ]: () => import( '@/views/pantone/pantoneList/PantoneList.vue' ),

    [ AsyncComponentPantoneEnum.ColorList ]: () => import( '@/views/pantone/colorList/ColorList.vue' ),
    [ AsyncComponentPantoneEnum.ColorListForm ]: () => import( '@/components/pantone/ColorListForm.vue' ),
    [ AsyncComponentPantoneEnum.ColorMutateForm ]: () => import( '@/components/pantone/ColorMutateForm.vue' ),
    [ AsyncComponentPantoneEnum.ColorMutate ]: () => import( '@/views/pantone/colorMutate/ColorMutate.vue' ),

    [ AsyncComponentPantoneEnum.PantoneColor ]: () => import( '@/components/pantone/PantoneColor.vue' ),
    [ AsyncComponentPantoneEnum.PantoneSelector ]: () => import( '@/components/pantone/PantoneSelector.vue' ),
    [ AsyncComponentPantoneEnum.ColorSelector ]: () => import( '@/components/pantone/ColorSelector.vue' ),
    [ AsyncComponentPantoneEnum.PantoneProductModel ]: () => import( '@/components/pantone/PantoneProductModel.vue' ),
    [ AsyncComponentPantoneEnum.MaterialTypeColorSelector ]: () => import( '@/components/pantone/MaterialTypeColorSelector.vue' ),
}
